import { Spin, Result, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { ACTION_TYPES } from "Store/models/auth";
import { useStoreActions, useStoreState } from "easy-peasy";
import "Styles/app.less";

const qs = require("qs");

const STATUS = {
  WAIT: 0,
  SUCCESS: 1,
  FAIL: 2,
};

export default function ConfirmEmail({ ...props }) {
  const [status, setStatus] = useState(STATUS.WAIT);

  const { confirmEmail } = useStoreActions((store) => store.auth);
  const { process } = useStoreState((store) => store.auth);

  let history = useHistory();
  let params = qs.parse(props.location.search.substring(1));

  useEffect(() => {
    const confirmationData = {
      userId: params.userId,
      token: params.tokenId,
    };

    confirmEmail(confirmationData);
  }, []);

  useEffect(() => {
    if (process === ACTION_TYPES.CONFIRMED_USER) {
      setStatus(STATUS.SUCCESS);
      setTimeout(() => {
        history.push("/login");
      }, 4000);
    }

    if (process === ACTION_TYPES.FAILED) {
      setStatus(STATUS.FAIL);
    }
  }, [process]);

  const renderContent = () => {
    switch (status) {
      case STATUS.WAIT:
        return (
          <Col>
            <Result
              icon={<Spin size="large" />}
              title="Aktivasyon gerçekleştiriliyor, lütfen bekleyiniz."
            />
          </Col>
        );
      case STATUS.SUCCESS:
        return (
          <Col>
            <Result
              status="success"
              title="Üyelik aktivasyonu başarıyla gerçekleştirildi"
              subTitle="Giriş sayfasına yönlendiriliyorsunuz"
            />
          </Col>
        );
      case STATUS.FAIL:
        return (
          <Col>
            <Result
              status="error"
              title="Üyelik aktivasyonu gerçekleştirilemedi"
              subTitle="Lütfen sistem yöneticiniz ile iletişime geçiniz"
            />
          </Col>
        );
    }
  };

  return (
    <div className={`confirm-email-form-wrapper ${props.wrapperHeight}`}>
      <Row className="confirm-email-form">{renderContent()}</Row>
    </div>
  );
}
